export const newLineChartColorValues = [
    '#26A9E0', '#A4C439', '#32859A', '#F1BF36', '#B3D1D6', '#F05C38', '#0E516E',
    '#628D33', '#B6CEAD', '#CEDC60', '#F6921E', '#4E666E', '#90CDBA', '#0D7075',
    '#7671A3', '#FFF17A', '#92BAAF', '#1BAEBD', '#053A65', '#C0DFD2', '#DCDFDE',
];
